var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6663 7.99992C14.6663 11.6818 11.6815 14.6666 7.99967 14.6666C4.31777 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31777 1.33325 7.99967 1.33325C11.6815 1.33325 14.6663 4.31802 14.6663 7.99992ZM11.589 6.58916L7.33307 10.8451L4.74381 8.25585L5.92233 7.07732L7.33307 8.48805L10.4105 5.41065L11.589 6.58916Z",
    fill: "#36C9A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.2ec0ae6b35be9c83c54955ab9e4fb87e.svg";
export { ForwardRef as ReactComponent };